import React from 'react';
import { useWalletConnect } from '../WalletConnectProvider';

function WalletButton({ handleConnectWallet }) {
  const { address, disconnect, connected } = useWalletConnect();

  const handleClick = () => {
    if (connected) {
      disconnect();
    } else {
      handleConnectWallet();
    }
  };

  return (
    <button className="btn connect-wallet" onClick={handleClick}>
      <span className="is-link has-text-weight-bold">
        {address && address.length > 0
          ? `${address.substring(0, 6)}...${address.substring(address.length - 4)}`
          : 'Connect Wallet'}
      </span>
    </button>
  );
}

export default WalletButton;
